import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'lsnDateTime'
})
export class LsnDateTimePipe extends DatePipe implements PipeTransform {
    transform(value: any, format = 'yyyy-MM-dd HH:mm:ss'): any {
        return value
            ? super.transform(value, format)
            : '-';
    }
}
